import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"menu\"><path d=\"M512 128c0 9-6 17-17 17H17c-11 0-17-8-17-17V64c0-9 6-17 17-17h480c9 2 15 8 15 17zm0 160c0 9-6 17-17 17H17c-8 0-17-6-17-17v-64c0-9 6-17 17-17h480c9 0 17 6 17 17v64zm0 160c0 9-6 17-17 17H17c-11-2-17-8-17-17v-64c0-9 6-17 17-17h480c9 0 17 6 17 17v64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu.svg
// module id = 186
// module chunks = 0